import { render, staticRenderFns } from "./StackedTable.vue?vue&type=template&id=bb5c6de8"
import script from "./StackedTable.vue?vue&type=script&lang=js"
export * from "./StackedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports